module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/screen-bg.9e6c36e3.png";